import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "reactstrap";
import Drawer from "../../../../components/Drawer";
import Topbar from "./Topbar";
import Overview from "../../../Profile/Overview";
import JobPay from "../../../Profile/JobPay";
import Personal from "../../../Profile/Personal";
import TimeOff from "../../../Profile/TimeOff";
import Documents from "../../../Profile/Documents";
import Notes from "../../../Profile/Notes";
import History from "./History";
import { ProfileProvider } from "../../../Profile/context";
import "./style.scss";

function ProfileDrawer({ user, visible, close }) {
	const { t } = useTranslation();
	const [menu, setMenu] = useState("job-pay");

	const content = useMemo(() => {
		switch (menu) {
			case "personal": {
				return <Personal isOpenFromTimesheet={true} />;
			}
			case "job-pay": {
				return <JobPay isOpenFromTimesheet={true} />;
			}
			case "time-off": {
				return <TimeOff isOpenFromTimesheet={true} />;
			}
			case "documents": {
				return <Documents isOpenFromTimesheet={true} />;
			}
			case "notes": {
				return <Notes isOpenFromTimesheet={true} />;
			}
			case "history": {
				return <History />
			}
			default:
				return <></>;
		}
	}, [menu]);

	return (
		<ProfileProvider id={user?.id} isSelf={false}>
			<Drawer
				open={visible}
				close={close}
				title={
					<>
						<h3 className="mb-0">{t("profile")}</h3>
						<h5 className="text-muted">
							{t("improve-business-efficiency")}
						</h5>
					</>
				}
			>
				<Topbar menu={menu} setMenu={setMenu} />

				<Overview />
				<Card className="profile-card">{content}</Card>
			</Drawer>
		</ProfileProvider>
	);
}

export default ProfileDrawer;
